import { useSearchParams } from 'react-router-dom';
import withMenuLayout from '@root/src/layout/withMenuLayout';
import { useFeatureFlags } from '@src/hooks';

import { Submissions } from './Submissions';
import { SubmissionsOpenSearch } from './SubmissionsOpenSearch';

export const SubmissionsRouter: React.FC = () => {
  const [searchParams] = useSearchParams();
  const getFeatureFlag = useFeatureFlags();
  const isOpenSearchEnabled = getFeatureFlag('OpenSearch') && searchParams.get('source') !== 'ddb';

  return isOpenSearchEnabled ? <SubmissionsOpenSearch /> : <Submissions />;
};

export const SubmissionsRouterPage = withMenuLayout(SubmissionsRouter);
